import { createSelector } from '@ngrx/store';
import { GatewayFirmwareUpdateStatus } from '@vi-iot/client/index';
import { AppState } from '../app.state';
import { GatewayFirmwareUpdateState } from './gateway-firmware-update.state';

export namespace GatewayFirmwareUpdateSelectors {
  export const gatewayFirmwareUpdateState = (state: AppState): GatewayFirmwareUpdateState =>
    state.gatewayFirmwareUpdate;

  export const getGatewayFirmwareUpdateStatus = createSelector(
    gatewayFirmwareUpdateState,
    (gatewayFirmwareUpdate: GatewayFirmwareUpdateState): GatewayFirmwareUpdateStatus =>
      gatewayFirmwareUpdate.status
  );
}
